// components/KucukcekmeceSidebar.jsx

import React from "react";
import { Link, useLocation } from "react-router-dom";

const ServiceArea = [
  {
    label: "Atatürk Mahallesi Halı Yıkama",
    path: "/kucukcekmece/ataturk-hali-yikama",
    description:
      "Atatürk Mahallesi’nde halılarınız modern sistemlerle derinlemesine yıkanır, aynı gün teslim edilir."
  },
  {
    label: "Sefaköy Halı Yıkama",
    path: "/kucukcekmece/sefakoy-hali-yikama",
    description:
      "Sefaköy semtinde antibakteriyel halı yıkama hizmeti sunuyoruz. Ücretsiz servisimizle kapıdan alım yapıyoruz."
  },
  {
    label: "Halkalı Halı Yıkama",
    path: "/kucukcekmece/halkali-hali-yikama",
    description:
      "Halkalı’da bulunan müşterilerimize özel indirimli ve garantili halı yıkama hizmetleri sunulmaktadır."
  },
  {
    label: "İnönü Mahallesi Halı Yıkama",
    path: "/kucukcekmece/inonu-hali-yikama",
    description:
      "İnönü Mahallesi'nde organik deterjanlarla sağlıklı ve hijyenik halı yıkama işlemleri yapılır."
  },
  {
    label: "Kanarya Mahallesi Halı Yıkama",
    path: "/kucukcekmece/kanarya-hali-yikama",
    description:
      "Kanarya bölgesine özel servisimizle halılarınız özenle yıkanır, aynı gün içinde teslim edilir."
  },
  {
    label: "Cennet Mahallesi Halı Yıkama",
    path: "/kucukcekmece/cennet-hali-yikama",
    description:
      "Cennet Mahallesi’nde tam otomatik makinelerle derinlemesine temizlik hizmeti sunuyoruz."
  },
];

const KucukcekmeceSidebar = () => {
  const location = useLocation();

  return (
    <div className="mt-2 text-[#003132]">
      <h2 className="text-lg font-semibold mb-2 uppercase tracking-wide text-center">KÜÇÜKÇEKMECE SERVİS ALANLARI</h2>

      <div className="bg-[#f1f5f9] p-4 rounded-xl shadow-sm space-y-3 border border-gray-200">
        {ServiceArea.map((area, index) => (
          <div key={index}>
            <Link
              to={area.path}
              className={`block text-sm font-semibold px-3 py-1 rounded-lg transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-red-600 text-white"
                  : "text-red-900 hover:bg-green-100 hover:text-red-800"
              }`}
            >
              {area.label}
            </Link>
            <p className="text-xs text-gray-600 mt-1 pl-1">{area.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KucukcekmeceSidebar;
